module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_24.2f97c4ad.mp3";